import { useCallback, useEffect, useState } from "react";
import { listarFornecedoresFinanceiro } from "../services/fornecedores-financeiro.service";
import type { FornecedorFinanceiroApi } from "../types/contas-pagar.types";

export type UseFornecedoresFinanceiroResult = {
  data: FornecedorFinanceiroApi[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
};

export function useFornecedoresFinanceiro(): UseFornecedoresFinanceiroResult {
  const [data, setData] = useState<FornecedorFinanceiroApi[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data: rows, status } = await listarFornecedoresFinanceiro();
        if (cancelled) return;
        if (status !== 200 || !rows) {
          setError("Não foi possível carregar fornecedores.");
          setData([]);
          return;
        }
        setData(rows);
      } catch (e: unknown) {
        if (cancelled) return;
        const msg =
          e instanceof Error ? e.message : "Falha ao carregar fornecedores.";
        setError(msg);
        setData([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    void run();
    return () => {
      cancelled = true;
    };
  }, [tick]);

  const refetch = useCallback(() => {
    setTick((n) => n + 1);
  }, []);

  return { data, loading, error, refetch };
}
